import { ArrowUpRight } from "lucide-react";

const NUMERI = [
  { id: "occupazione", label: "Occupazione media", prima: "40%", dopo: "75%" },
  { id: "adr", label: "Prezzo medio a notte", prima: "75 €", dopo: "95 €" },
  { id: "revpar", label: "Ricavo per notte disponibile*", prima: "30 €", dopo: "71 €" },
];

const PERCORSO = [
  "Nessun rialzo improvviso: i prezzi sono saliti poco alla volta, anno dopo anno, seguendo la percezione degli ospiti. Prima migliori l'esperienza e le recensioni, poi alzi il prezzo.",
  "Occupazione e prezzo medio sono cresciuti insieme. Riempire svendendo non è un risultato: qui è salito tutto.",
  "Più fatturato, più recensioni, più visibilità: per gli algoritmi di Booking e Airbnb i due residence sono diventati un punto di riferimento sul mercato palermitano.",
];

const LINKS = [
  { name: "Open Sicily Quattro Canti Apartments", url: "https://www.booking.com/hotel/it/open-sicily-residence.it.html" },
  { name: "Open Sicily Homes · Stazione Centrale", url: "https://www.booking.com/hotel/it/open-sicily-homes-residence-gran-palermo.it.html" },
];

export default function CasoStudio() {
  return (
    <div data-testid="caso-studio" className="border border-[#383029] bg-[#16110E] p-6 sm:p-10">
      <p className="section-kicker">Un caso concreto, con i miei numeri</p>
      <h3 className="mt-4 max-w-3xl font-heading text-2xl font-black uppercase leading-[1.05] tracking-tight text-[#FAF7F2] sm:text-3xl">
        OpenSicily Homes, Palermo: dal 40% al 75% di occupazione in tre anni.
      </h3>
      <p className="mt-5 max-w-2xl text-base font-light leading-relaxed text-[#C4BBB0] sm:hidden">
        È la mia società: due residence a Palermo, 15 appartamenti. Numeri miei, condivisi con la stessa trasparenza che avrai tu.
      </p>
      <p className="mt-5 hidden max-w-2xl text-base font-light leading-relaxed text-[#C4BBB0] sm:block sm:text-lg">
        È la mia società: due residence nel centro storico di Palermo, 15 appartamenti in totale. Li porto come esempio perché sono numeri miei, li conosco giorno per giorno e posso condividerli con totale trasparenza — la stessa che avrai tu sulla tua struttura.
      </p>

      <div className="mt-8 grid gap-px bg-[#383029] sm:grid-cols-3">
        {NUMERI.map((n) => (
          <div key={n.id} data-testid={`caso-studio-${n.id}`} className="bg-[#16110E] p-5 sm:p-6">
            <p className="font-mono text-xs uppercase tracking-widest text-[#A89F91]">{n.label}</p>
            <p className="mt-3 flex items-baseline gap-3">
              <span className="font-heading text-2xl font-black tracking-tighter text-[#686054] line-through decoration-[#E05A2C] decoration-2">{n.prima}</span>
              <span className="font-heading text-3xl font-black tracking-tighter text-[#FAF7F2] sm:text-4xl">{n.dopo}</span>
            </p>
          </div>
        ))}
      </div>
      <p className="mt-3 hidden font-mono text-xs uppercase tracking-widest text-[#686054] sm:block">
        *Calcolato: occupazione × prezzo medio. Sui 15 appartamenti, a parità di notti, il ricavo è più che raddoppiato.
      </p>

      <div className="hidden sm:block"><p className="mt-8 section-kicker">Com'è andata, in pratica</p></div>
      <ul className="mt-4 hidden space-y-4 sm:block">
        {PERCORSO.map((item, i) => (
          <li key={item} data-testid={`caso-studio-punto-${i + 1}`} className="flex gap-4 text-sm font-light leading-relaxed text-[#C4BBB0] sm:text-base">
            <span className="shrink-0 font-heading font-black text-[#E05A2C]">—</span>
            {item}
          </li>
        ))}
      </ul>

      <div className="mt-8 hidden border-t border-[#383029] pt-6 sm:block">
        <p className="text-sm text-[#A89F91]">Non credermi sulla parola: i due residence sono su Booking, con punteggi e recensioni pubblici.</p>
        <div className="mt-4 flex flex-wrap gap-3">
          {LINKS.map((l, i) => (
            <a
              key={l.url}
              href={l.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`caso-studio-link-${i + 1}`}
              className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-[#383029] px-5 py-2.5 text-sm text-[#FAF7F2] transition-colors duration-300 hover:border-[#E05A2C] hover:text-[#E05A2C]"
            >
              {l.name}
              <ArrowUpRight className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
